var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 134"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 143",
    x: 1.46729,
    y: 1.5,
    width: 16,
    height: 21,
    rx: 3,
    stroke: "#454D66",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 144",
    x: 4.46729,
    y: 4.5,
    width: 10,
    height: 2,
    fill: "#454D66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 145",
    x: 4.46729,
    y: 8.5,
    width: 2,
    height: 2,
    fill: "#454D66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 148",
    x: 4.46729,
    y: 12.5,
    width: 2,
    height: 2,
    fill: "#454D66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 151",
    x: 4.46729,
    y: 16.5,
    width: 2,
    height: 2,
    fill: "#454D66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 146",
    x: 8.46729,
    y: 8.5,
    width: 2,
    height: 2,
    fill: "#454D66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 149",
    x: 8.46729,
    y: 12.5,
    width: 2,
    height: 2,
    fill: "#454D66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 152",
    x: 8.46729,
    y: 16.5,
    width: 2,
    height: 2,
    fill: "#454D66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 147",
    x: 12.4673,
    y: 8.5,
    width: 2,
    height: 2,
    fill: "#454D66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 150",
    x: 12.4673,
    y: 12.5,
    width: 2,
    height: 2,
    fill: "#454D66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 153",
    x: 12.4673,
    y: 16.5,
    width: 2,
    height: 2,
    fill: "#454D66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.9abf8a3ced5eb6f69cf21a555cae3617.svg";
export { ForwardRef as ReactComponent };